class MonthlyReportingRowController {

    constructor(
        appConfig,
        Utils
    ) {
        'ngInject';

        this.appConfig = appConfig;
        this.Utils = Utils;
    }

    $onInit() {
        this.displayValues = {};
        this.columns.map((column) => {
            this.displayValues[column.text] = this.Utils.getNestedProperty(this.report, column.nestedDisplayKeys);
        });

    }

}

export default MonthlyReportingRowController;


// WEBPACK FOOTER //
// ./app/common/monthly-reporting/monthly-reporting-row/monthly-reporting-row-controller.js